import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {Url} from 'url';
import {AppComponent} from '../../app.component';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private route: Router
    ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | UrlTree | Promise<boolean> | UrlTree | boolean | UrlTree {
    if (sessionStorage.getItem('isConnected') === 'true') {
      return true;
    } else {
      this.route.navigate(['/']);
      return false;
    }
  }
}
